var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompiling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68568 19.4887C3.09989 20.0745 3.09989 21.0243 3.68568 21.6101L8.98898 26.9134C9.57477 27.4991 10.5245 27.4991 11.1103 26.9134L16.4136 21.6101C16.9994 21.0243 16.9994 20.0745 16.4136 19.4887L11.1103 14.1854C10.5245 13.5996 9.57477 13.5996 8.98898 14.1854L3.68568 19.4887ZM24.6857 19.4887C24.0999 20.0745 24.0999 21.0243 24.6857 21.6101L29.989 26.9134C30.5748 27.4991 31.5245 27.4991 32.1103 26.9134L37.4136 21.6101C37.9994 21.0243 37.9994 20.0745 37.4136 19.4887L32.1103 14.1854C31.5245 13.5997 30.5748 13.5997 29.989 14.1854L24.6857 19.4887Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1857 8.98874C13.5999 9.57452 13.5999 10.5243 14.1857 11.1101L19.489 16.4134C20.0748 16.9991 21.0245 16.9991 21.6103 16.4134L26.9136 11.1101C27.4994 10.5243 27.4994 9.57452 26.9136 8.98873L21.6103 3.68543C21.0245 3.09965 20.0748 3.09965 19.489 3.68543L14.1857 8.98874ZM14.1857 29.9887C13.5999 30.5745 13.5999 31.5243 14.1857 32.1101L19.489 37.4134C20.0748 37.9991 21.0245 37.9991 21.6103 37.4134L26.9136 32.1101C27.4994 31.5243 27.4994 30.5745 26.9136 29.9887L21.6103 24.6854C21.0245 24.0996 20.0748 24.0996 19.489 24.6854L14.1857 29.9887Z",
    fill: "#00A3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompiling);
export default __webpack_public_path__ + "static/media/compiling.8a6ee8999c92ecb812058c7144702b72.svg";
export { ForwardRef as ReactComponent };